const fromTemperature = temp => {
  if (!temp) return Comfort.unknown
  else if (temp >= 0 && temp < 70) return Comfort.cold
  else if (temp < 75) return Comfort.cozy
  else if (temp < 80) return Comfort.warm
  else if (temp >= 80) return Comfort.hot
  else return Comfort.unknown
}

const Comfort = {
  fromTemperature,

  cold: 'Cold',
  cozy: 'Cozy',
  warm: 'Warm',
  hot: 'Hot',
  unknown: 'N/A',
}

export default Comfort



// WEBPACK FOOTER //
// ./src/helpers/Comfort.js